/**
 * Avalna Email Signup Banner
 *
 * No AJAX — uses native form submission. Shopify's /contact endpoint POSTs,
 * redirects back with form.posted_successfully? / form.errors baked into the
 * server-rendered HTML. This JS only scrolls to the result after redirect.
 */
const AvalnaEmailSignup = (() => {
  function init() {
    const container = document.querySelector('[data-avalna-email-signup]');
    if (!container) return;

    const success = container.querySelector('.avalna-email-signup__success');
    const error = container.querySelector('.avalna-email-signup__error-message--visible');

    if (success || error) {
      const target = success || error;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { init };
})();
